export default __webpack_public_path__ + "static/media/bet_war_of_bets.e729b67d.png";